import React from "react";
import PropTypes from "prop-types";
import cc from "classcat";
import { twMerge } from "tailwind-merge";
PrivatePageHeader.propTypes = {
    children: PropTypes.node.isRequired,
    tabs: PropTypes.node,
    className: PropTypes.string
};
export default function PrivatePageHeader(param) {
    var children = param.children, className = param.className, tabs = param.tabs;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: twMerge(cc([
            "mb-4 flex flex-col items-center justify-center gap-x-3 gap-y-3 sm:mt-0 sm:flex-row sm:justify-between",
            className
        ]))
    }, children), tabs && /*#__PURE__*/ React.createElement("div", {
        className: "mb-4"
    }, tabs));
}
